import { FolderStarMultipleOutlineIcon } from './FolderStarMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C7DD0CB0-EEA4-4D24-BCE2-8184382EF419
 * name folder-star-multiple-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-star-multiple-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderFavoriteMultipleOutlineIcon = FolderStarMultipleOutlineIcon;
export default FolderFavoriteMultipleOutlineIcon